import BurningThroughSpace from './Burning Through Space Homage.webp';
import Hands from './hands.webp';
import Heavy from './Heavy.webp';
import Light from './Light.webp';
import Medic from './Medic.webp';
import NovaDucks from './Nova Ducks.webp';
import ScrapBackground from './scrapbackground.webp';
import Space from './space.webp';
import Remaster from './The Remaster.webp';

export default {
    Hands,
    BurningThroughSpace,
    Heavy,
    Light,
    Medic,
    NovaDucks,
    ScrapBackground,
    Space,
    Remaster
}